import { IDs } from '../../helpers/IDs';
import { getCO2AequivalentSubscope24_Fahrzeuge, getCO2AequivalentSubscope24_Raeume, getCO2Aequivalent } from './getCO2Aequivalent';
import { getStaticOption } from '../../core/forms/helpers/getStaticOption';
import { checkEnergiedatenAuswahl } from '../../bereiche/dateneingabe/assistent/assistent_config';
import { getSachanlagenStructure } from '../../bereiche/dateneingabe/functions/getEnergiedatenStructure';
import { getDatenqualitaet } from './getDatenqualitaet';
import { makeSimpleKennzahl } from './strukturiert/makeKennzahl';
import { Kennzahl, getKennzahl } from './strukturiert/Kennzahl';
import { setKennzahl } from './strukturiert/KennzahlTools';
import { KennzahlFaktor } from './strukturiert/KennzahlFaktor';

export function processKennzahlenBerechnung24(data: any, item: any, jahr: number, standort: any) {
    const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
        || ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_orig !== 1;
    let rows_fahrzeuge: Array<any> = data[IDs.ENT_ANGEMIETETE_FAHRZEUGE] || [];
    let rows_raeume_angemietet: Array<any> = data[IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN] || [];
    let rows_raeume_eigen: Array<any> = data[IDs.ENT_EIGENE_RAEUMLICHKEITEN] || [];

    const structSachanlagen = getSachanlagenStructure();
    structSachanlagen.forEach((s: any) => {
        if (s.key === IDs.ENT_ANGEMIETETE_FAHRZEUGE) {
            rows_fahrzeuge = rows_fahrzeuge.filter((r: any) => checkEnergiedatenAuswahl(data, r.standort_tid_orig, +jahr, s));
        } else if (s.key === IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN) {
            rows_raeume_angemietet = rows_raeume_angemietet.filter((r: any) => checkEnergiedatenAuswahl(data, r.standort_tid_orig, +jahr, s));
        } else if (s.key === IDs.ENT_EIGENE_RAEUMLICHKEITEN) {
            rows_raeume_eigen = rows_raeume_eigen.filter((r: any) => checkEnergiedatenAuswahl(data, r.standort_tid_orig, +jahr, s));
        }
    });

    rows_raeume_eigen.forEach((re: any) => re.isEigen = true);

    let rows_raeume = rows_raeume_angemietet;
    if (standort && (standort.standort_typ_tid_orig === 5 || standort.standort_typ_tid_orig === 6)) {
        rows_raeume = [...rows_raeume_angemietet, ...rows_raeume_eigen];
    }

    // console.log('Eigen:', rows_raeume_eigen, standort);

    const key_fzg_wert = 'co2_fussabdruck_angemietete_fahrzeuge_wert';
    const key_fzg_items = 'co2_fussabdruck_angemietete_fahrzeuge_items';
    const key_fzg_menge = 'co2_fussabdruck_angemietete_fahrzeuge_menge';
    const key_fzg_faktor_map = 'co2_fussabdruck_angemietete_fahrzeuge_faktor_map';
    const key_fzg_datenqualitaet = 'co2_fussabdruck_angemietete_fahrzeuge_arr_datenqualitaet';
    const key_fzg_strom_wert = 'co2_fussabdruck_angemietete_fahrzeuge_strom_wert';
    const key_fzg_strom_items = 'co2_fussabdruck_angemietete_fahrzeuge_strom_items';
    const key_fzg_strom_menge = 'co2_fussabdruck_angemietete_fahrzeuge_strom_menge';
    const key_fzg_strom_datenqualitaet = 'co2_fussabdruck_angemietete_fahrzeuge_strom_arr_datenqualitaet';
    const key_fzg_strom_faktor_map = 'co2_fussabdruck_angemietete_fahrzeuge_faktor_map_e';
    const key_fzg_strom_quelle = 'faktor_quelle_strom_co2_fzg';
    const key_angemietet_strom = 'co2_fussabdruck_angemietet_strom_wert';
    const key_angemietet_waerme = 'co2_fussabdruck_angemietet_waerme_wert';
    const key_angemietet_ww = 'co2_fussabdruck_angemietet_ww_wert';
    const key_angemietet_kaelte = 'co2_fussabdruck_angemietet_kaelte_wert';
    const key_angemietet_strom_menge = 'co2_fussabdruck_angemietet_strom_menge';
    const key_angemietet_waerme_menge = 'co2_fussabdruck_angemietet_waerme_menge';
    const key_angemietet_ww_menge = 'co2_fussabdruck_angemietet_ww_menge';
    const key_angemietet_kaelte_menge = 'co2_fussabdruck_angemietet_kaelte_menge';
    const key_angemietet_strom_datenqualitaet = 'co2_fussabdruck_angemietet_strom_arr_datenqualitaet';
    const key_angemietet_waerme_datenqualitaet = 'co2_fussabdruck_angemietet_waerme_arr_datenqualitaet';
    const key_angemietet_ww_datenqualitaet = 'co2_fussabdruck_angemietet_ww_arr_datenqualitaet';
    const key_angemietet_kaelte_datenqualitaet = 'co2_fussabdruck_angemietet_kaelte_arr_datenqualitaet';
    const key_angemietet_strom_quellen = 'faktor_quelle_strom_co2_raum';
    const key_angemietet_waerme_quellen = 'faktor_quelle_rw_co2_raum';
    const key_angemietet_ww_quellen = 'faktor_quelle_ww_co2_raum';
    const key_eigene_strom = 'co2_fussabdruck_eigene_strom_wert';
    const key_eigene_waerme = 'co2_fussabdruck_eigene_waerme_wert';
    const key_eigene_ww = 'co2_fussabdruck_eigene_ww_wert';
    const key_eigene_kaelte = 'co2_fussabdruck_eigene_kaelte_wert';

    if (item[key_fzg_wert]) {
        item[key_fzg_wert] = 0;
    }
    if (item[key_fzg_menge]) {
        item[key_fzg_menge] = 0;
    }
    if (item[key_fzg_items]) {
        item[key_fzg_items] = [];
    }
    if (item[key_fzg_strom_wert]) {
        item[key_fzg_strom_wert] = 0;
    }
    if (item[key_fzg_strom_menge]) {
        item[key_fzg_strom_menge] = 0;
    }
    if (item[key_fzg_strom_items]) {
        item[key_fzg_strom_items] = [];
    }
    if (item[key_angemietet_strom]) {
        item[key_angemietet_strom] = 0;
    }
    if (item[key_angemietet_waerme]) {
        item[key_angemietet_waerme] = 0;
    }
    if (item[key_angemietet_ww]) {
        item[key_angemietet_ww] = 0;
    }
    if (item[key_angemietet_kaelte]) {
        item[key_angemietet_kaelte] = 0;
    }
    if (item[key_eigene_strom]) {
        item[key_eigene_strom] = 0;
    }
    if (item[key_eigene_waerme]) {
        item[key_eigene_waerme] = 0;
    }
    if (item[key_eigene_ww]) {
        item[key_eigene_ww] = 0;
    }
    if (item[key_eigene_kaelte]) {
        item[key_eigene_kaelte] = 0;
    }

    rows_fahrzeuge.filter((row: any) => +row.jahr === +jahr && (!standort || (standort.tid === row.standort_tid_orig)))
        .forEach((row: any) => {
            row = { ...row };
            const aq = getCO2AequivalentSubscope24_Fahrzeuge(data, jahr, row);
            const value = +row.entfernung * aq.wert;
            const value_s3 = +row.entfernung * aq.wert_s3;
            const kraftstoff = row.kraftstoff;
            row.value = value;
            row.name = row.transportmittel;
            row.datenqualitaet = aq.datenqualitaet;
            row.menge = row.entfernung;
            row.faktor = aq.wert * 1000000;
            row.faktor_einheit = 'gCO₂Äq/km';
            if (!item[key_fzg_items]) {
                item[key_fzg_items] = [];
            }
            if (!item[key_fzg_strom_items]) {
                item[key_fzg_strom_items] = [];
            }
            const faktor_info = row.transportmittel + '_' + row.kraftstoff;
            const transportmittelInfo = getStaticOption(IDs.ENT_ANGEMIETETE_FAHRZEUGE, 'transportmittel', row.transportmittel, null, true);
            const kraftstoffInfo = getStaticOption(IDs.ENT_ANGEMIETETE_FAHRZEUGE, 'kraftstoff', row.kraftstoff, null, true);
            let showname = transportmittelInfo;
            if (kraftstoffInfo) {
                showname += ' / ' + kraftstoffInfo;
            }
            if (row.kraftstoff === 'strom' || row.kraftstoff === 'strom_regenerativ') {
                item[key_fzg_strom_items].push(row);
                item[key_fzg_strom_wert] = (item[key_fzg_strom_wert] || 0) + (row.value || 0);
                item[key_fzg_strom_menge] = (item[key_fzg_strom_menge] || 0) + (row.menge || 0);
                item[key_fzg_strom_quelle] = aq.quelle;
                if (!item[key_fzg_strom_faktor_map]) {
                    item[key_fzg_strom_faktor_map] = {};
                }
                item[key_fzg_strom_faktor_map][faktor_info] = { wert: aq.wert * 1000000, einheit: 'gCO₂Äq/km', quelle: aq.quelle, aq, showname };
                if (!item[key_fzg_strom_datenqualitaet]) {
                    item[key_fzg_strom_datenqualitaet] = [];
                }
                item[key_fzg_strom_datenqualitaet].push({
                    wert: row.value,
                    emissionsfaktor: +aq.datenqualitaet,
                    bewertung: 1,
                    datenherkunft: +row.datenherkunft
                });
                console.log('Angemietet Fzg Strom', row, item[key_fzg_strom_datenqualitaet]);
            } else {
                item[key_fzg_items].push(row);
                item[key_fzg_wert] = (item[key_fzg_wert] || 0) + (row.value || 0);
                item[key_fzg_menge] = (item[key_fzg_menge] || 0) + (row.menge || 0);
                if (!item[key_fzg_faktor_map]) {
                    item[key_fzg_faktor_map] = {};
                }
                item[key_fzg_faktor_map][faktor_info] = { wert: aq.wert * 1000000, einheit: 'gCO₂Äq/km', quelle: aq.quelle, aq, showname };
                // DQ
                if (!item[key_fzg_datenqualitaet]) {
                    item[key_fzg_datenqualitaet] = [];
                }
                item[key_fzg_datenqualitaet].push({
                    wert: row.value,
                    emissionsfaktor: +aq.datenqualitaet,
                    bewertung: 1,
                    datenherkunft: +row.datenherkunft
                });
                // console.log('Angemietet Fzg', row, item[key_fzg_datenqualitaet]);

            }
            const row2: any = {};
            row2.tid = 'fzg' + row.tid; // für die Kennzahl
            row2.value = value_s3;
            row2.name = 'Angemietet ' + transportmittelInfo;
            if (kraftstoffInfo) {
                row2.name += ' / ' + kraftstoffInfo;
            }
            row2.quelle = aq.quelle_s3;
            row2.faktor = aq.wert_s3 * 1000000;
            row2.decimals = 0;
            row2.faktor_einheit = 'gCO₂Äq/km';
            row2.einheit = 'km';
            row2.menge = +row.entfernung;
            row2.datenqualitaet = aq.datenqualitaet_s3;
            const key_wert_s3 = 'co2_fussabdruck_s3_ss3_wert';
            const key_items_s3 = 'co2_fussabdruck_s3_ss3_items';

            if (!disabledCO2Komplex) {
                item[key_items_s3].push(row2);
                item[key_wert_s3] = (item[key_wert_s3] || 0) + (value_s3 || 0);
            }
            // Kennzahl
            if (standort && !disabledCO2Komplex) {
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row2.tid, jahr, standort.tid, row.tid,
                    'Entfernung/Verbrauch', row2.name, row2.menge, row2.value, row2.einheit,
                    aq.wert_s3, aq.quelle_s3, data,  'tCO₂Äq/km');

                if (row.kraftstoff === 'strom' || row.kraftstoff === 'strom_regenerativ') {
                    const kenn = setKennzahl(standort.tid, data, 'Entfernung Angemietete Fzg. (Strom)', Kennzahl.BEREICH_SCOPE3, 'angemietete_fahrzeuge_strom', 'entfernung', row, 'km');
                    kenn.setInfo(`${transportmittelInfo} / ${kraftstoffInfo}`);
                    if (aq) {
                        const kenn_co2 = setKennzahl(standort.tid, data, 'CO2-Emissionen Angemietete Fzg. (Strom)', Kennzahl.BEREICH_SCOPE3, 'angemietete_fahrzeuge_strom_co2', 'entfernung',
                            row, 'tCO₂Äq', 'km', undefined, undefined, undefined, undefined, aq.wert, aq.quelle, 'tCO₂Äq/km');
                        kenn_co2.setInfo(`${transportmittelInfo} / ${kraftstoffInfo}`);
                    }
                } else {
                    const kenn = setKennzahl(standort.tid, data, 'Entfernung Angemietete Fzg.', Kennzahl.BEREICH_SCOPE2, 'angemietete_fahrzeuge', 'entfernung', row, 'km');
                    kenn.setInfo(`${transportmittelInfo} / ${kraftstoffInfo}`);
                    if (aq) {
                        const kenn_co2 = setKennzahl(standort.tid, data, 'CO2-Emissionen Angemietete Fzg.', Kennzahl.BEREICH_SCOPE2, 'angemietete_fahrzeuge_co2', 'entfernung',
                            row, 'tCO₂Äq', 'km', undefined, undefined, undefined, undefined, aq.wert, aq.quelle, 'tCO₂Äq/km');
                        kenn_co2.setInfo(`${transportmittelInfo} / ${kraftstoffInfo}`);
                    }
                }
            }

            if (true || standort) {
                if (row.kraftstoff === 'strom' || row.kraftstoff === 'strom_regenerativ') {
                    item.co2_fussabdruck_scope2 = (item.co2_fussabdruck_scope2 || 0) + (row.value || 0);
                    // console.log('Ang.Fzg.Strom:', row.value, item.co2_fussabdruck_scope2);
                } else {
                    item.co2_fussabdruck_scope1 = (item.co2_fussabdruck_scope1 || 0) + (row.value || 0);
                }
                item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);
                item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row2.value || 0);
                item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row2.value || 0);
            }
        });

    rows_raeume_angemietet.filter((row: any) => +row.jahr === +jahr && (!standort || (standort.tid === row.standort_tid_orig)))
        .forEach((row: any) => {
            const aq = getCO2AequivalentSubscope24_Raeume(data, jahr, row.nutzungsart);
            const days_total = (jahr % 4 === 0 && jahr % 100 !== 0) ? 366 : 365;
            const hours_total = days_total * 24;


            const flaeche = +row.flaeche;
            const flaeche_gebaeude = +row.flaeche_gebaeude;
            const nutzungstage = +row.nutzungstage;
            const nutzungszeit = +row.nutzungszeit;
            const nutzungsstunden = nutzungstage * nutzungszeit;
            const faktor_stunden = nutzungsstunden / hours_total;
            // Flags

            const beheizt = row.beheizt_orig === 1;
            const warmwasser = row.warmwasser_orig === 1;
            const entfeuchtet = row.entfeuchtet_orig === 1;
            const belueftet = row.belueftet_orig === 1;
            const klimatisiert_strom = row.klimatisiert_strom_orig === 1;
            const klimatisiert_fernkaelte = row.klimatisiert_fernkaelte_orig === 1;
            const faktor_kaelte = +row.faktor_kaelte ? row.faktor_kaelte / 1000000 : 0;

            // Berechnung

            const stromverbrauch_luftfoerderung = aq.luftfoerderung * flaeche;
            const stromverbrauch_beleuchtung = aq.beleuchtung * flaeche;

            const energieverbrauch_heizung = aq.heizenergie * flaeche * (4.53 * flaeche_gebaeude ** (-0.215) + 0.27);
            const stromverbrauch_warmwasser = aq.warmwasser * flaeche * (0.352 * 0.9 * (4.53 * flaeche_gebaeude ** (-0.215) + 0.27));
            const energieverbrauch_warmwasser = aq.warmwasser * flaeche * ((1 - 0.352) * 0.9 * (4.53 * flaeche_gebaeude ** (-0.215) + 0.27));

            const stromverbrauch_kaelte = aq.kuehlkaelte * flaeche;
            const waermeverbrauch_kaelte = stromverbrauch_kaelte * 4;
            const stromverbrauch_hilfsenergie_kaelte = aq.hilfsenergie_kaelte * flaeche;
            const stromverbrauch_befeuchtung = aq.befeuchtung * flaeche;
            const waermeverbrauch_befeuchtung = stromverbrauch_befeuchtung * 4;

            const stromverbrauch_arbeitshilfen = aq.arbeitshilfen * flaeche;

            /// Jetzt nur noch die Ergebnisse ...

            const ergebnis_verbrauch_heizung = (beheizt ? energieverbrauch_heizung : 0) * faktor_stunden;
            const ergebnis_verbrauch_warmwasser = (warmwasser ? energieverbrauch_warmwasser : 0) * faktor_stunden;
            const ergebnis_stromverbrauch = (stromverbrauch_beleuchtung +
                stromverbrauch_arbeitshilfen +
                (warmwasser ? stromverbrauch_warmwasser : 0) +
                (belueftet ? stromverbrauch_luftfoerderung : 0) +
                (klimatisiert_strom ? (stromverbrauch_kaelte + stromverbrauch_hilfsenergie_kaelte) : 0) +
                (klimatisiert_fernkaelte ? stromverbrauch_hilfsenergie_kaelte : 0) +
                (klimatisiert_strom && entfeuchtet ? stromverbrauch_befeuchtung : 0)) * faktor_stunden;
            const ergebnis_energieverbrauch_kaelte = ((klimatisiert_fernkaelte ? waermeverbrauch_kaelte : 0) +
                (klimatisiert_fernkaelte && entfeuchtet ? waermeverbrauch_befeuchtung : 0)) * faktor_stunden;

            // console.log('Strom', stromverbrauch_beleuchtung, stromverbrauch_arbeitshilfen, stromverbrauch_warmwasser, stromverbrauch_luftfoerderung, stromverbrauch_kaelte);
            const aq_strom = getCO2Aequivalent(data, jahr, 'strom', false);
            const aq_rw = getCO2Aequivalent(data, jahr, 'raumwaerme', false);
            const aq_ww = getCO2Aequivalent(data, jahr, 'warmwasser', false);
            const aq_kaelte = getCO2Aequivalent(data, jahr, 'fernkaelte', false);

            const value_strom = ergebnis_stromverbrauch * aq_strom.wert;
            const value_rw = ergebnis_verbrauch_heizung * aq_rw.wert;
            const value_ww = ergebnis_verbrauch_warmwasser * aq_ww.wert;
            const value_ka = ergebnis_energieverbrauch_kaelte * faktor_kaelte;

            // console.log('Kaelte: ', ergebnis_energieverbrauch_kaelte, value_ka, row);


            // console.log('Raum S: ', ergebnis_stromverbrauch, value_strom, aq_strom);
            // console.log('Raum W: ', ergebnis_verbrauch_heizung, value_rw, aq_rw);
            // console.log('Raum WW: ', ergebnus_verbrauch_warmwasser, value_ww, aq_ww);

            const value_strom_s3 = ergebnis_stromverbrauch * aq_strom.wert3;
            const value_rw_s3 = ergebnis_verbrauch_heizung * aq_rw.wert3;
            const value_ww_s3 = ergebnis_verbrauch_warmwasser * aq_ww.wert3;
            const value_kaelte_s3 = ergebnis_energieverbrauch_kaelte * aq_kaelte.wert3;

            const arr_datenqualitaet_s3_strom = [];
            const arr_datenqualitaet_s3_rw = [];
            const arr_datenqualitaet_s3_ww = [];

            if (row.isEigen) {
                // console.log('Eigen!!!: ', row);
                if (!item[key_eigene_strom]) {
                    item[key_eigene_strom] = value_strom;
                } else {
                    item[key_eigene_strom] += value_strom;
                }
                if (!item[key_eigene_waerme]) {
                    item[key_eigene_waerme] = value_rw;
                } else {
                    item[key_eigene_waerme] += value_rw;
                }
                if (!item[key_eigene_ww]) {
                    item[key_eigene_ww] = value_ww;
                } else {
                    item[key_eigene_ww] += value_ww;
                }
                if (!item[key_eigene_kaelte]) {
                    item[key_eigene_kaelte] = value_ka;
                } else {
                    item[key_eigene_kaelte] += value_ka;
                }
            } else {
                if (!item[key_angemietet_strom]) {
                    item[key_angemietet_strom] = value_strom;
                    item[key_angemietet_strom_menge] = ergebnis_stromverbrauch;
                } else {
                    item[key_angemietet_strom] += value_strom;
                    item[key_angemietet_strom_menge] += ergebnis_stromverbrauch;
                }
                if (!item[key_angemietet_strom_datenqualitaet]) {
                    item[key_angemietet_strom_datenqualitaet] = [];
                }
                item[key_angemietet_strom_datenqualitaet].push({
                    wert: ergebnis_stromverbrauch,
                    emissionsfaktor: +aq_strom.datenqualitaet_1,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                arr_datenqualitaet_s3_strom.push({
                    wert: ergebnis_stromverbrauch,
                    emissionsfaktor: +aq_strom.datenqualitaet_2,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                if (!item[key_angemietet_strom_quellen]) {
                    item[key_angemietet_strom_quellen] = aq_strom.quelle;
                } else if (item[key_angemietet_strom_quellen].indexOf(aq_strom.quelle) === -1) {
                    item[key_angemietet_strom_quellen] += ';;' + aq_strom.quelle;
                }
                if (!item[key_angemietet_waerme]) {
                    item[key_angemietet_waerme] = value_rw;
                    item[key_angemietet_waerme_menge] = ergebnis_verbrauch_heizung;
                } else {
                    item[key_angemietet_waerme] += value_rw;
                    item[key_angemietet_waerme_menge] += ergebnis_verbrauch_heizung;
                }
                if (!item[key_angemietet_waerme_datenqualitaet]) {
                    item[key_angemietet_waerme_datenqualitaet] = [];
                }
                item[key_angemietet_waerme_datenqualitaet].push({
                    wert: ergebnis_verbrauch_heizung,
                    emissionsfaktor: +aq_rw.datenqualitaet_1,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                arr_datenqualitaet_s3_rw.push({
                    wert: ergebnis_verbrauch_heizung,
                    emissionsfaktor: +aq_rw.datenqualitaet_2,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                if (!item[key_angemietet_ww_quellen]) {
                    item[key_angemietet_ww_quellen] = aq_rw.quelle;
                } else if (item[key_angemietet_ww_quellen].indexOf(aq_ww.quelle) === -1) {
                    item[key_angemietet_ww_quellen] += ';;' + aq_ww.quelle;
                }
                if (!item[key_angemietet_ww]) {
                    item[key_angemietet_ww] = value_ww;
                    item[key_angemietet_ww_menge] = ergebnis_verbrauch_warmwasser;
                } else {
                    item[key_angemietet_ww] += value_ww;
                    item[key_angemietet_ww_menge] += ergebnis_verbrauch_warmwasser;
                }
                if (!item[key_angemietet_ww_datenqualitaet]) {
                    item[key_angemietet_ww_datenqualitaet] = [];
                }
                item[key_angemietet_ww_datenqualitaet].push({
                    wert: ergebnis_verbrauch_warmwasser,
                    emissionsfaktor: +aq_ww.datenqualitaet_1,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                arr_datenqualitaet_s3_ww.push({
                    wert: ergebnis_verbrauch_heizung,
                    emissionsfaktor: +aq_ww.datenqualitaet_2,
                    bewertung: 3,    // Schlecht
                    datenherkunft: 3 // Schätzung
                });
                if (!item[key_angemietet_waerme_quellen]) {
                    item[key_angemietet_waerme_quellen] = aq_rw.quelle;
                } else if (item[key_angemietet_waerme_quellen].indexOf(aq_rw.quelle) === -1) {
                    item[key_angemietet_waerme_quellen] += ';;' + aq_rw.quelle;
                }
                if (!item[key_angemietet_kaelte]) {
                    item[key_angemietet_kaelte] = value_ka;
                } else {
                    item[key_angemietet_kaelte] += value_ka;
                }
            }
            // console.log('Strom', value_strom_s3, aq_strom.wert3, ergebnis_stromverbrauch);

            setKennzahlS2('s2_raeume_strom', 'Strom', row, ergebnis_stromverbrauch, aq_strom, data, standort);
            setKennzahlS2('s2_raeume_waerme', 'Wärme', row, ergebnis_verbrauch_heizung, aq_rw, data, standort);
            setKennzahlS2('s2_raeume_ww', 'Warmwasser', row, ergebnis_verbrauch_warmwasser, aq_ww, data, standort);
            setKennzahlS2('s2_raeume_kaelte', 'Fernkälte', row, ergebnis_energieverbrauch_kaelte, aq_kaelte, data, standort);
            // Für Location-Based-Berechnung
            if (ergebnis_stromverbrauch > 0 && standort) {
                item.strom_bundesdurchschnitt = (ergebnis_stromverbrauch || 0) + (item.strom_bundesdurchschnitt || 0);
                item.co2_strom_bundesdurchschnitt = (value_strom || 0) + (item.co2_strom_bundesdurchschnitt || 0);
                data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt = (ergebnis_stromverbrauch || 0) + ( data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt || 0);
                data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt =  (value_strom || 0) + ( data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt || 0);
                const kenn_bundesdurchschnitt: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                const kenn_bundesdurchschnitt_co2: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'co2', jahr, standort ? standort.tid : 'ALL', data);
                let kenn_item_bundesdurchschnitt: Kennzahl;
                if (!kenn_bundesdurchschnitt.isInitialized()) {
                    kenn_bundesdurchschnitt
                        .setEinheit('kWh')
                        .setBereich(Kennzahl.BEREICH_SCOPE2)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('Verbrauch Strom Bundesdurchschnitt');
                }
                kenn_item_bundesdurchschnitt = kenn_bundesdurchschnitt.addValue(Math.round(ergebnis_stromverbrauch), item.tid);
                kenn_item_bundesdurchschnitt
                    .setType(Kennzahl.TYPE_EINGABE);
                const co2_faktor_strom: any = getCO2Aequivalent(data, jahr, 'strom', false) || {};
                if (!kenn_bundesdurchschnitt_co2.isInitialized()) {
                    kenn_bundesdurchschnitt_co2
                        .setEinheit('tCO₂Äq')
                        .setBereich(Kennzahl.BEREICH_SCOPE2)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('CO₂-Emission Strom Bundesdurchschnitt');
                }
                const kenn_item_bundesdurchschnitt_co2: Kennzahl = kenn_bundesdurchschnitt_co2.addValue(value_strom, item.tid);
                kenn_item_bundesdurchschnitt_co2
                    .setType(Kennzahl.TYPE_BERECHNUNG)
                    .addItem(kenn_item_bundesdurchschnitt)
                    .addFaktor(co2_faktor_strom.wert, KennzahlFaktor.TYPE_CO2, co2_faktor_strom.quelle, 'CO₂-Faktor')
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);

            }
            if (!disabledCO2Komplex) {
                addSS3Row(item, 'Strom', value_strom_s3, aq_strom.wert3, ergebnis_stromverbrauch, aq_strom.quelle, row.isEigen, getDatenqualitaet(arr_datenqualitaet_s3_strom), data, standort, row.tid);
                addSS3Row(item, 'Wärme', value_rw_s3, aq_rw.wert3, ergebnis_verbrauch_heizung, aq_rw.quelle, row.isEigen, getDatenqualitaet(arr_datenqualitaet_s3_rw), data, standort, row.tid);
                addSS3Row(item, 'Warmwasser', value_ww_s3, aq_ww.wert3, ergebnis_verbrauch_warmwasser, aq_ww.quelle, row.isEigen, getDatenqualitaet(arr_datenqualitaet_s3_ww), data, standort, row.tid);
                addSS3Row(item, 'Fernkälte', value_kaelte_s3, aq_kaelte.wert3, ergebnis_verbrauch_warmwasser, aq_ww.quelle, row.isEigen, getDatenqualitaet(arr_datenqualitaet_s3_ww), data, standort, row.tid);
            }

            if (true || standort) {
                item.co2_fussabdruck_scope1 = (item.co2_fussabdruck_scope1 || 0) + (value_rw || 0) + (value_ww || 0);
                item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (value_rw || 0) + (value_ww || 0);
                item.co2_fussabdruck_scope2 = (item.co2_fussabdruck_scope2 || 0) + (value_strom || 0) + (value_ka || 0);
                item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (value_strom || 0) + (value_ka || 0);
            }
            // console.log('2.4 Raum', aq, row);
        });
}

function setKennzahlS2(kennKey: string, name: string, row: any, menge: number, factor: any, data: any, standort: any) {
    const rowCopy = { ...row };
    rowCopy.menge = menge;
    const kennName = name + (row.isEigen ? ' (Eigene Räumlichkeiten)' : ' (Angemietete Räumlichkeiten)');
    const einheit = 'kWh';
    const faktor_einheit = 'tCO₂Äq/kWh';
    if (standort) {
        setKennzahl(standort.tid, data, `Verbrauch ${kennName}`, Kennzahl.BEREICH_SCOPE2, kennKey, 'menge', rowCopy, einheit);
        if (factor) {
            setKennzahl(standort.tid, data, `CO₂-Emission ${kennName}`, Kennzahl.BEREICH_SCOPE2, `${kennKey}_co2`, 'menge', rowCopy,
                'tCO₂Äq', einheit, undefined, undefined, undefined, undefined, factor.wert, factor.quelle, faktor_einheit);
        }
    }
}

function addSS3Row(item: any, name: string, value_s3: number, factor_s3: number, menge: number,
    quelle: string, isEigen: boolean, datenqualitaet: number, data: any, standort: any, rowid: number) {
    if (!value_s3) {
        return;
    }
    const row2: any = {};
    row2.value = value_s3;
    row2.name = name + (isEigen ? ' (Eigene Räumlichkeiten)' : ' (Angemietete Räumlichkeiten)');
    row2.faktor = factor_s3 * 1000000;
    row2.decimals = 0;
    row2.quelle = quelle;
    row2.faktor_einheit = 'tCO₂Äq/kWh';
    row2.einheit = 'kWh';
    row2.menge = menge;
    row2.datenqualitaet = datenqualitaet;
    if (standort) {
        makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row2.tid, item.jahr, standort.tid, row2.tid,
            'Menge', row2.name, row2.menge, row2.value, row2.einheit,
            factor_s3, quelle, data);
    }
    const key_wert_s3 = 'co2_fussabdruck_s3_ss3_wert';
    const key_items_s3 = 'co2_fussabdruck_s3_ss3_items';
    item[key_items_s3].push(row2);
    item[key_wert_s3] = (item[key_wert_s3] || 0) + (value_s3 || 0);
    if (true) {
        item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (value_s3 || 0);
        item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (value_s3 || 0);

    }
}
